import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { forgotPassword } from "../../state/reducers/forgotPassword.js";
import CustomButton from "../../common-components/button/Button.jsx";
import InputField from "../../common-components/input-field/Input-field.jsx";
import { Row, Col } from "react-bootstrap";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [validationMessages, setValidationMessages] = useState({ email: "" });
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) {
      return "Email is required.";
    } else if (!emailRegex.test(email)) {
      return "Please enter a valid email address.";
    }
    return "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const emailError = validateEmail(email);

    if (emailError) {
      setValidationMessages({ email: emailError });
      return;
    }

    setIsLoading(true);
    try {
      const payload = { email };
      await dispatch(forgotPassword(payload));
      setMessage("If an account with that email exists, a reset link has been sent.");
      navigate("/reset-password");
    } catch (error) {
      setMessage("Something went wrong. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="page-wrapper login-page forgot-password-page">
      <div className="left-panel">
        <img src="./images/login-img.png" alt="" className="login-img" />
      </div>
      <div className="right-panel">
        <div className="login-wrapper">
          <div className="login-page-title text-center">
            <h2>Reset Your Password</h2>
            <div className="logo-wrapper justify-content-center d-flex">
              <img src="./images/ust_logo.svg" alt="" className="ust-logo me-3" />
              <h1>Code Crafter</h1>
            </div>
          </div>
          <div className="login-panel justify-content-center">
            <form className="login-form" onSubmit={handleSubmit}>
              <Row className="mb-3">
                <Col xs={12}>
                  <InputField
                    key='email'
                    type="email"
                    label="Email"
                    name="email"
                    value={email}
                    id='email'
                    onChange={(e) => {
                      setEmail(e.target.value);
                      setValidationMessages({ ...validationMessages, email: "" });
                    }}
                    layoutStyle="vertical"
                    placeholder="Enter your email"
                    required
                    validationMsg={validationMessages.email}
                  />
                </Col>
              </Row>

              {message && <p>{message}</p>}
              <Row className="justify-content-center">
                <Col>
                  <CustomButton 
                    label="Forgot Password" 
                    type="submit"
                    disabled={isLoading}
                    onClick={handleSubmit}
                    className="login-btn" 
                  />
                </Col>
              </Row>
            </form>
          </div>
          <div className="register mt-2">
            <div><Link to="/login">Back to Login</Link></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
